export const generatedRuntimeClosurePacket = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-21T00:00:00.000Z",
  "mode": "deterministic-runtime-closure-packet",
  "operatingRule": "Runtime closure packets translate sidecar campaign blockers into exact setup, run, intake, review, and regeneration steps. They are not science evidence.",
  "contractCount": 5,
  "campaignCount": 6,
  "closedCurrentReproducibleCount": 2,
  "promotedButCurrentReproducibilityBlockedCount": 0,
  "readyToGenerateCount": 0,
  "blockedBeforeGenerationCount": 3,
  "closureStateCounts": {
    "closed-currently-reproducible": 2,
    "blocked-before-runtime-generation": 3
  },
  "blockerClassCounts": {
    "build-artifact": 1,
    "input-custody": 1,
    "system-runtime": 1,
    "external-application": 1,
    "python-package": 1
  },
  "customerUseAllowed": false,
  "commercialUseAllowed": false,
  "evidenceHashes": {
    "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
    "runtimeValidationCampaignLedger": "sha256-7d6f913ac6a611baf6052809984397293a597736628121801cff5135edc9a45b",
    "sidecarPromotionLedger": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6",
    "sidecarRunSpecPacket": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
    "sidecarWorkOrderPacket": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
    "runtimeDependencyCustodyLedger": "sha256-0c9052094b6255deb28219335af3145a130567d90f111695be765341252c44d1"
  },
  "closureRecords": [
    {
      "contractId": "spice-gf-event-window-v1",
      "tool": "NASA NAIF SPICE Geometry Finder",
      "domain": "ephemeris-event-windows",
      "sourceIds": [
        "spice-gf"
      ],
      "closureState": "closed-currently-reproducible",
      "readinessState": "runtime-artifact-promoted",
      "reproducibilityState": "promoted-artifact-currently-reproducible",
      "latestPreflightCanReproduce": true,
      "bestPreflightCanReproduce": true,
      "promotedArtifactId": "spice-gf-runtime-mercury-clear-link-22deg-2025",
      "promotedArtifactHash": "sha256-6bba7e3d4ceef9f865c3cf9acee8fe83bd68bf0d803fafb7b852530cffcad8f0",
      "readinessHash": "sha256-a30df59ba18a6787ab37d68842db0d846b284c3c00af038b144fe3a2027ff6d3",
      "campaignRefs": [
        {
          "id": "campaign-spice-contact-windows",
          "title": "SPICE contact and solar-interference windows",
          "priorityLane": "P0-critical-path",
          "campaignStatus": "runtime-promoted-currently-reproducible",
          "campaignHash": "sha256-462420fcd20cbc0ba392b0abb149494b622e04cfd25b622c7e86c32a8f797fc3"
        }
      ],
      "workOrderRef": {
        "id": "work-order-spice-gf-event-window-v1",
        "commandTemplate": "python sidecars/spice_gf/run_spice_gf.py --scenario <scenarioId> --kernel-manifest <kernelManifest.json> --constraints <constraints.json> --out artifacts/sidecars/spice-gf-event-window-v1.json",
        "requiredOutputPath": "artifacts/sidecars/spice-gf-event-window-v1.json",
        "workOrderHash": "sha256-28129dc4f5b602e71d08f8d395f99a34f947b41c576c5b070c8a2c010456ce42"
      },
      "runSpecRef": {
        "id": "run-spec-spice-gf-event-window-v1",
        "commandTemplate": "python sidecars/spice_gf/run_spice_gf.py --scenario <scenarioId> --kernel-manifest <kernelManifest.json> --constraints <constraints.json> --out artifacts/sidecars/spice-gf-event-window-v1.json",
        "outputPath": "artifacts/sidecars/spice-gf-event-window-v1.json",
        "runSpecHash": "sha256-a416865942c7d332b206a4cebcfc9068c9006dbf4222dc7dbc26437a2b986f4c"
      },
      "setupActions": [],
      "blockerClasses": [],
      "blockerCount": 0,
      "blockers": [],
      "executionCommands": {
        "preflightCapture": "npm run science:sidecar:runtime-preflight:capture",
        "generateArtifact": "python sidecars/spice_gf/run_spice_gf.py --scenario <scenarioId> --kernel-manifest <kernelManifest.json> --constraints <constraints.json> --out artifacts/sidecars/spice-gf-event-window-v1.json",
        "validateArtifact": "node scripts/validate-sidecar-intake.mjs --out evidence/sidecar-intake-reports/spice-gf-event-window-v1-runtime-intake-report.json artifacts/sidecars/spice-gf-event-window-v1.json",
        "regenerateEvidence": "npm run science:sidecar:promotion && npm run science:sidecar:readiness && npm run science:runtime-campaigns && npm run science:runtime-closure && npm run science:release"
      },
      "requiredOutputPath": "artifacts/sidecars/spice-gf-event-window-v1.json",
      "intakeReportPath": "evidence/sidecar-intake-reports/spice-gf-event-window-v1-runtime-intake-report.json",
      "acceptanceChecklist": [
        "Preflight is current and ready-to-run in the execution shell.",
        "Artifact artifactState is runtime-generated and produced by the sidecar worker, not hand-authored or fixture-derived.",
        "Runtime artifact includes required field: toolVersion.",
        "Runtime artifact includes required field: runAt.",
        "Runtime artifact includes required field: scenarioId.",
        "Runtime artifact includes required field: kernelSet.",
        "Runtime artifact includes required field: kernelHashes.",
        "Runtime artifact includes required field: timeScale.",
        "Runtime artifact includes required field: gfConstraint.",
        "Runtime artifact includes required field: eventWindows.",
        "Runtime artifact includes required field: units.",
        "Runtime artifact includes required field: uncertainty.",
        "Runtime artifact includes required field: reproducibleCommand.",
        "Runtime artifact includes required field: inputsHash.",
        "Runtime artifact includes required field: outputsHash.",
        "Runtime artifact includes required field: checksums.",
        "Runtime artifact includes required field: limitations.",
        "Runtime artifact includes required field: validationStatus.",
        "Artifact validationStatus is passed.",
        "Artifact sourceIds match the contract source IDs.",
        "Artifact includes reproducibleCommand, inputsHash, outputsHash, and checksums.",
        "Artifact passes npm run science:sidecar:intake and writes an intake report.",
        "A reviewer approves claim-level use before scenario decisions or customer packages change.",
        "Run-spec gate: Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated..",
        "Run-spec gate: inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns..",
        "Run-spec gate: Output JSON validates through `npm run science:sidecar:intake` without blockers..",
        "Run-spec gate: The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports..",
        "Run-spec gate: SPICE kernel coverage, TDB/ET time key, confinement window, GF constraint, and event-window endpoints are recorded.."
      ],
      "nextAction": "Regenerate current-shell preflight and reviewer acceptance before using the promoted artifact in customer deliverables.",
      "evidenceBoundary": "Runtime closure records are execution governance only. They do not promote science, trajectory, resource, economics, or customer claims until the referenced runtime artifact and intake report pass.",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "closureHash": "sha256-9861ade8237cc4f239ec855110505fb9ad893200bee6b96fb63969131069c073"
    },
    {
      "contractId": "orekit-propagation-v1",
      "tool": "Orekit",
      "domain": "trajectory-propagation",
      "sourceIds": [
        "orekit"
      ],
      "closureState": "blocked-before-runtime-generation",
      "readinessState": "blocked-runtime-prerequisites",
      "reproducibilityState": "no-promoted-artifact-runtime-blocked",
      "latestPreflightCanReproduce": false,
      "bestPreflightCanReproduce": false,
      "promotedArtifactId": null,
      "promotedArtifactHash": null,
      "readinessHash": "sha256-766c85f8a86b7afda85840908f7f16dd955f47faf2f8df79420fd6ec53f1d1ff",
      "campaignRefs": [
        {
          "id": "campaign-orekit-propagation",
          "title": "Orekit propagation and event checks",
          "priorityLane": "P0-critical-path",
          "campaignStatus": "blocked-runtime-prerequisites",
          "campaignHash": "sha256-34e5be85925dbc6bf6a3acb190d67f8c3d409469f12f69f7ca321872ac2e6a33"
        },
        {
          "id": "campaign-cross-tool-residual-frontier",
          "title": "Cross-tool residual frontier",
          "priorityLane": "P0-critical-path",
          "campaignStatus": "blocked-runtime-prerequisites",
          "campaignHash": "sha256-8e5b0be0f6654f91a37027e198b2e9d892fc3d05e9415ab90f90f520d2e06638"
        }
      ],
      "workOrderRef": {
        "id": "work-order-orekit-propagation-v1",
        "commandTemplate": "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
        "requiredOutputPath": "artifacts/sidecars/orekit-propagation-v1.json",
        "workOrderHash": "sha256-69e531fee46ffac8b1b6865c5bc3cc5248c7b3d18f193615a03cd44aedd404b7"
      },
      "runSpecRef": {
        "id": "run-spec-orekit-propagation-v1",
        "commandTemplate": "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
        "outputPath": "artifacts/sidecars/orekit-propagation-v1.json",
        "runSpecHash": "sha256-6760d4cf3d986ffb70f72246168ab2562bc9b35b7dc40400d0cba01b759d29dd"
      },
      "setupActions": [
        {
          "probeId": "java-runtime",
          "ok": false,
          "blockerClass": "system-runtime",
          "setupAction": "Install a reviewed Java runtime compatible with the Orekit sidecar build and record `java -version` output.",
          "verificationCommand": "java -version",
          "custodyNote": "Record Java vendor/version, Gradle build output, Orekit dependency version, sidecar jar hash, and OREKIT_DATA_PATH hash."
        },
        {
          "probeId": "orekit-data-path",
          "ok": false,
          "blockerClass": "input-custody",
          "setupAction": "Set OREKIT_DATA_PATH to a reviewed Orekit data archive or directory with time-scale, Earth orientation, and ephemeris data.",
          "verificationCommand": "test -e \"$OREKIT_DATA_PATH\"",
          "custodyNote": "Record archive/directory hash, data-source notes, coverage date, and any redistribution/license constraints."
        },
        {
          "probeId": "orekit-sidecar-jar",
          "ok": false,
          "blockerClass": "build-artifact",
          "setupAction": "Build the Orekit sidecar jar from sidecars/orekit after Java/Gradle dependencies are reviewed.",
          "verificationCommand": "test -f \"$OREKIT_SIDECAR_JAR\"",
          "custodyNote": "Record build command, source tree hash, dependency lock/version output, jar hash, and reviewer approval."
        }
      ],
      "blockerClasses": [
        "build-artifact",
        "input-custody",
        "system-runtime"
      ],
      "blockerCount": 3,
      "blockers": [
        "Missing command/runtime: Java",
        "Missing path or env input: OREKIT_DATA_PATH",
        "Missing path or env input: OREKIT_SIDECAR_JAR",
        "Runtime artifact is not promoted."
      ],
      "executionCommands": {
        "preflightCapture": "npm run science:sidecar:runtime-preflight:capture",
        "generateArtifact": "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
        "validateArtifact": "node scripts/validate-sidecar-intake.mjs --out evidence/sidecar-intake-reports/orekit-propagation-v1-runtime-intake-report.json artifacts/sidecars/orekit-propagation-v1.json",
        "regenerateEvidence": "npm run science:sidecar:promotion && npm run science:sidecar:readiness && npm run science:runtime-campaigns && npm run science:runtime-closure && npm run science:release"
      },
      "requiredOutputPath": "artifacts/sidecars/orekit-propagation-v1.json",
      "intakeReportPath": "evidence/sidecar-intake-reports/orekit-propagation-v1-runtime-intake-report.json",
      "acceptanceChecklist": [
        "Preflight is current and ready-to-run in the execution shell.",
        "Artifact artifactState is runtime-generated and produced by the sidecar worker, not hand-authored or fixture-derived.",
        "Runtime artifact includes required field: toolVersion.",
        "Runtime artifact includes required field: runAt.",
        "Runtime artifact includes required field: scenarioId.",
        "Runtime artifact includes required field: dataContext.",
        "Runtime artifact includes required field: frames.",
        "Runtime artifact includes required field: timeScale.",
        "Runtime artifact includes required field: forceModel.",
        "Runtime artifact includes required field: events.",
        "Runtime artifact includes required field: units.",
        "Runtime artifact includes required field: uncertainty.",
        "Runtime artifact includes required field: reproducibleCommand.",
        "Runtime artifact includes required field: inputsHash.",
        "Runtime artifact includes required field: outputsHash.",
        "Runtime artifact includes required field: checksums.",
        "Runtime artifact includes required field: independentComparison.",
        "Runtime artifact includes required field: limitations.",
        "Runtime artifact includes required field: validationStatus.",
        "Artifact validationStatus is passed.",
        "Artifact sourceIds match the contract source IDs.",
        "Artifact includes reproducibleCommand, inputsHash, outputsHash, and checksums.",
        "Artifact passes npm run science:sidecar:intake and writes an intake report.",
        "A reviewer approves claim-level use before scenario decisions or customer packages change.",
        "Run-spec gate: Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated..",
        "Run-spec gate: inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns..",
        "Run-spec gate: Output JSON validates through `npm run science:sidecar:intake` without blockers..",
        "Run-spec gate: The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports..",
        "Run-spec gate: independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact.."
      ],
      "nextAction": "Resolve runtime prerequisites: Missing command/runtime: Java; Missing path or env input: OREKIT_DATA_PATH; Missing path or env input: OREKIT_SIDECAR_JAR.",
      "evidenceBoundary": "Runtime closure records are execution governance only. They do not promote science, trajectory, resource, economics, or customer claims until the referenced runtime artifact and intake report pass.",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "closureHash": "sha256-0680305ee69e8c919ba9921eabcf929dc7d73c1a314883c5e9018fb139531824"
    },
    {
      "contractId": "gmat-transfer-v1",
      "tool": "NASA GMAT",
      "domain": "mission-design-transfer",
      "sourceIds": [
        "gmat"
      ],
      "closureState": "blocked-before-runtime-generation",
      "readinessState": "blocked-runtime-prerequisites",
      "reproducibilityState": "no-promoted-artifact-runtime-blocked",
      "latestPreflightCanReproduce": false,
      "bestPreflightCanReproduce": false,
      "promotedArtifactId": null,
      "promotedArtifactHash": null,
      "readinessHash": "sha256-408221cbd9d34c1317b3307812c441a055fd024676a92c4d421b5b82d5679baf",
      "campaignRefs": [
        {
          "id": "campaign-gmat-transfer",
          "title": "GMAT transfer and constraint residuals",
          "priorityLane": "P0-critical-path",
          "campaignStatus": "blocked-runtime-prerequisites",
          "campaignHash": "sha256-c53e6e950ae8a2f0c08b1e20e266a4cedbcd3a50650849182257416abec9feb2"
        },
        {
          "id": "campaign-cross-tool-residual-frontier",
          "title": "Cross-tool residual frontier",
          "priorityLane": "P0-critical-path",
          "campaignStatus": "blocked-runtime-prerequisites",
          "campaignHash": "sha256-8e5b0be0f6654f91a37027e198b2e9d892fc3d05e9415ab90f90f520d2e06638"
        }
      ],
      "workOrderRef": {
        "id": "work-order-gmat-transfer-v1",
        "commandTemplate": "python sidecars/gmat/run_gmat_transfer.py --scenario <scenarioId> --manifest <gmat-script-manifest.json> --report <reviewed-gmat-run-report.json> --out artifacts/sidecars/gmat/gmat-transfer-v1.json",
        "requiredOutputPath": "artifacts/sidecars/gmat/gmat-transfer-v1.json",
        "workOrderHash": "sha256-fe29e92d043ca958978f5f4495f54e42bb1b84cdf0965ca5db25f5e77b1f0b8d"
      },
      "runSpecRef": {
        "id": "run-spec-gmat-transfer-v1",
        "commandTemplate": "python sidecars/gmat/run_gmat_transfer.py --scenario <scenarioId> --manifest <gmat-script-manifest.json> --report <reviewed-gmat-run-report.json> --out artifacts/sidecars/gmat/gmat-transfer-v1.json",
        "outputPath": "artifacts/sidecars/gmat/gmat-transfer-v1.json",
        "runSpecHash": "sha256-0557d81b6167b827573059307a15c3621f69f6b35008f5bdef748f9280fee3d8"
      },
      "setupActions": [
        {
          "probeId": "gmat-executable",
          "ok": false,
          "blockerClass": "external-application",
          "setupAction": "Install NASA GMAT, set GMAT_BIN to the tested executable path, and record the executable/version evidence.",
          "verificationCommand": "$GMAT_BIN --help",
          "custodyNote": "Record GMAT version, script hash, force-model assumptions, run logs, and output manifest hash before sidecar intake."
        }
      ],
      "blockerClasses": [
        "external-application"
      ],
      "blockerCount": 1,
      "blockers": [
        "Missing command/runtime: GMAT",
        "Runtime artifact is not promoted."
      ],
      "executionCommands": {
        "preflightCapture": "npm run science:sidecar:runtime-preflight:capture",
        "generateArtifact": "python sidecars/gmat/run_gmat_transfer.py --scenario <scenarioId> --manifest <gmat-script-manifest.json> --report <reviewed-gmat-run-report.json> --out artifacts/sidecars/gmat/gmat-transfer-v1.json",
        "validateArtifact": "node scripts/validate-sidecar-intake.mjs --out evidence/sidecar-intake-reports/gmat-transfer-v1-runtime-intake-report.json artifacts/sidecars/gmat/gmat-transfer-v1.json",
        "regenerateEvidence": "npm run science:sidecar:promotion && npm run science:sidecar:readiness && npm run science:runtime-campaigns && npm run science:runtime-closure && npm run science:release"
      },
      "requiredOutputPath": "artifacts/sidecars/gmat/gmat-transfer-v1.json",
      "intakeReportPath": "evidence/sidecar-intake-reports/gmat-transfer-v1-runtime-intake-report.json",
      "acceptanceChecklist": [
        "Preflight is current and ready-to-run in the execution shell.",
        "Artifact artifactState is runtime-generated and produced by the sidecar worker, not hand-authored or fixture-derived.",
        "Runtime artifact includes required field: gmatVersion.",
        "Runtime artifact includes required field: runAt.",
        "Runtime artifact includes required field: scenarioId.",
        "Runtime artifact includes required field: scriptHash.",
        "Runtime artifact includes required field: epoch.",
        "Runtime artifact includes required field: forceModel.",
        "Runtime artifact includes required field: optimizer.",
        "Runtime artifact includes required field: trajectorySummary.",
        "Runtime artifact includes required field: constraintSummary.",
        "Runtime artifact includes required field: units.",
        "Runtime artifact includes required field: uncertainty.",
        "Runtime artifact includes required field: reproducibleCommand.",
        "Runtime artifact includes required field: inputsHash.",
        "Runtime artifact includes required field: outputsHash.",
        "Runtime artifact includes required field: checksums.",
        "Runtime artifact includes required field: independentComparison.",
        "Runtime artifact includes required field: limitations.",
        "Runtime artifact includes required field: validationStatus.",
        "Artifact validationStatus is passed.",
        "Artifact sourceIds match the contract source IDs.",
        "Artifact includes reproducibleCommand, inputsHash, outputsHash, and checksums.",
        "Artifact passes npm run science:sidecar:intake and writes an intake report.",
        "A reviewer approves claim-level use before scenario decisions or customer packages change.",
        "Run-spec gate: Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated..",
        "Run-spec gate: inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns..",
        "Run-spec gate: Output JSON validates through `npm run science:sidecar:intake` without blockers..",
        "Run-spec gate: The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports..",
        "Run-spec gate: independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact.."
      ],
      "nextAction": "Resolve runtime prerequisites: Missing command/runtime: GMAT.",
      "evidenceBoundary": "Runtime closure records are execution governance only. They do not promote science, trajectory, resource, economics, or customer claims until the referenced runtime artifact and intake report pass.",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "closureHash": "sha256-479bf8e7620ba57bf5b6d7f1e9e8bc45f8c5ab0febc5db44aa5364edf16e543c"
    },
    {
      "contractId": "tudat-transfer-v1",
      "tool": "Tudat",
      "domain": "cross-tool-trajectory-validation",
      "sourceIds": [
        "tudat"
      ],
      "closureState": "blocked-before-runtime-generation",
      "readinessState": "blocked-runtime-prerequisites",
      "reproducibilityState": "no-promoted-artifact-runtime-blocked",
      "latestPreflightCanReproduce": false,
      "bestPreflightCanReproduce": false,
      "promotedArtifactId": null,
      "promotedArtifactHash": null,
      "readinessHash": "sha256-88e50b4ad7e5b4bb915d0efcafffbce64a9efdfd7a78c57c1e1794833ae2a558",
      "campaignRefs": [
        {
          "id": "campaign-tudat-cross-check",
          "title": "Tudat third-tool trajectory cross-check",
          "priorityLane": "P0-critical-path",
          "campaignStatus": "blocked-runtime-prerequisites",
          "campaignHash": "sha256-acf23215d3bb46936335c11ff99cc341490a625810d4895ab6894955cf54ab38"
        },
        {
          "id": "campaign-cross-tool-residual-frontier",
          "title": "Cross-tool residual frontier",
          "priorityLane": "P0-critical-path",
          "campaignStatus": "blocked-runtime-prerequisites",
          "campaignHash": "sha256-8e5b0be0f6654f91a37027e198b2e9d892fc3d05e9415ab90f90f520d2e06638"
        }
      ],
      "workOrderRef": {
        "id": "work-order-tudat-transfer-v1",
        "commandTemplate": "python sidecars/tudat/run_tudat_transfer.py --scenario <scenarioId> --settings <bodySettings.json> --report <reviewed-tudat-run-report.json> --out artifacts/sidecars/tudat/tudat-transfer-v1.json",
        "requiredOutputPath": "artifacts/sidecars/tudat/tudat-transfer-v1.json",
        "workOrderHash": "sha256-762279e25442533a1eb05a89ea533c13c672334e6f1bc44279885dc56a2d8ff8"
      },
      "runSpecRef": {
        "id": "run-spec-tudat-transfer-v1",
        "commandTemplate": "python sidecars/tudat/run_tudat_transfer.py --scenario <scenarioId> --settings <bodySettings.json> --report <reviewed-tudat-run-report.json> --out artifacts/sidecars/tudat/tudat-transfer-v1.json",
        "outputPath": "artifacts/sidecars/tudat/tudat-transfer-v1.json",
        "runSpecHash": "sha256-f67dfda77ada00ef1724aa13e103ecd7be2d0e9e02418042971bc39a22369e39"
      },
      "setupActions": [
        {
          "probeId": "python-module-tudatpy",
          "ok": false,
          "blockerClass": "python-package",
          "setupAction": "Install TudatPy in a reviewed virtual environment using sidecars/tudat/requirements.txt.",
          "verificationCommand": "python -c \"import tudatpy; import importlib.metadata as m; print(m.version('tudatpy'))\"",
          "custodyNote": "Record TudatPy version, environment lock or requirements hash, body settings hash, and cross-tool comparison plan."
        }
      ],
      "blockerClasses": [
        "python-package"
      ],
      "blockerCount": 1,
      "blockers": [
        "Missing Python module: tudatpy",
        "Runtime artifact is not promoted."
      ],
      "executionCommands": {
        "preflightCapture": "npm run science:sidecar:runtime-preflight:capture",
        "generateArtifact": "python sidecars/tudat/run_tudat_transfer.py --scenario <scenarioId> --settings <bodySettings.json> --report <reviewed-tudat-run-report.json> --out artifacts/sidecars/tudat/tudat-transfer-v1.json",
        "validateArtifact": "node scripts/validate-sidecar-intake.mjs --out evidence/sidecar-intake-reports/tudat-transfer-v1-runtime-intake-report.json artifacts/sidecars/tudat/tudat-transfer-v1.json",
        "regenerateEvidence": "npm run science:sidecar:promotion && npm run science:sidecar:readiness && npm run science:runtime-campaigns && npm run science:runtime-closure && npm run science:release"
      },
      "requiredOutputPath": "artifacts/sidecars/tudat/tudat-transfer-v1.json",
      "intakeReportPath": "evidence/sidecar-intake-reports/tudat-transfer-v1-runtime-intake-report.json",
      "acceptanceChecklist": [
        "Preflight is current and ready-to-run in the execution shell.",
        "Artifact artifactState is runtime-generated and produced by the sidecar worker, not hand-authored or fixture-derived.",
        "Runtime artifact includes required field: toolVersion.",
        "Runtime artifact includes required field: runAt.",
        "Runtime artifact includes required field: scenarioId.",
        "Runtime artifact includes required field: bodySettings.",
        "Runtime artifact includes required field: integrator.",
        "Runtime artifact includes required field: propagatorSettings.",
        "Runtime artifact includes required field: trajectorySummary.",
        "Runtime artifact includes required field: residualSummary.",
        "Runtime artifact includes required field: units.",
        "Runtime artifact includes required field: uncertainty.",
        "Runtime artifact includes required field: reproducibleCommand.",
        "Runtime artifact includes required field: inputsHash.",
        "Runtime artifact includes required field: outputsHash.",
        "Runtime artifact includes required field: checksums.",
        "Runtime artifact includes required field: independentComparison.",
        "Runtime artifact includes required field: limitations.",
        "Runtime artifact includes required field: validationStatus.",
        "Artifact validationStatus is passed.",
        "Artifact sourceIds match the contract source IDs.",
        "Artifact includes reproducibleCommand, inputsHash, outputsHash, and checksums.",
        "Artifact passes npm run science:sidecar:intake and writes an intake report.",
        "A reviewer approves claim-level use before scenario decisions or customer packages change.",
        "Run-spec gate: Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated..",
        "Run-spec gate: inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns..",
        "Run-spec gate: Output JSON validates through `npm run science:sidecar:intake` without blockers..",
        "Run-spec gate: The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports..",
        "Run-spec gate: independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact.."
      ],
      "nextAction": "Resolve runtime prerequisites: Missing Python module: tudatpy.",
      "evidenceBoundary": "Runtime closure records are execution governance only. They do not promote science, trajectory, resource, economics, or customer claims until the referenced runtime artifact and intake report pass.",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "closureHash": "sha256-e40b92b6c47017730c5c96f4aabf5a5194389cc23c0dbbc959508ed6495cd228"
    },
    {
      "contractId": "openmdao-dymos-optimization-v1",
      "tool": "OpenMDAO/Dymos",
      "domain": "optimization-and-sensitivity",
      "sourceIds": [
        "openmdao",
        "dymos"
      ],
      "closureState": "closed-currently-reproducible",
      "readinessState": "runtime-artifact-promoted",
      "reproducibilityState": "promoted-artifact-currently-reproducible",
      "latestPreflightCanReproduce": true,
      "bestPreflightCanReproduce": true,
      "promotedArtifactId": "openmdao-dymos-runtime-moon-logistics-beta-optimization",
      "promotedArtifactHash": "sha256-4ae76fa49e39336042cd1e76f36873c538a5a60e80e5194289d5a1daf909b896",
      "readinessHash": "sha256-6c97cc882c1df4c7705d2dda567cd773d0dbf2397ade5edbb0514b9aaaebb1d5",
      "campaignRefs": [
        {
          "id": "campaign-openmdao-dymos-sensitivity",
          "title": "OpenMDAO/Dymos logistics sensitivity replay",
          "priorityLane": "P1-business-grade",
          "campaignStatus": "runtime-promoted-currently-reproducible",
          "campaignHash": "sha256-28ead518f55addb23e76eb96ca9c3f8a3bf0d9da09ffb6c1bb636e4c02f372b0"
        }
      ],
      "workOrderRef": {
        "id": "work-order-openmdao-dymos-optimization-v1",
        "commandTemplate": "python sidecars/openmdao_dymos/run_optimization.py --problem artifacts/sidecars/openmdao_dymos/moon-logistics-beta.problem.json --out artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
        "requiredOutputPath": "artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
        "workOrderHash": "sha256-1ce46385d38db2f60463bcece1fffd0384f58b63d8f7c30ca9c777ac046ece55"
      },
      "runSpecRef": {
        "id": "run-spec-openmdao-dymos-optimization-v1",
        "commandTemplate": "python sidecars/openmdao_dymos/run_optimization.py --problem artifacts/sidecars/openmdao_dymos/moon-logistics-beta.problem.json --out artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
        "outputPath": "artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
        "runSpecHash": "sha256-282d8d68479110e12375b4ee39ea99c50bc9b58767b28570ab5c3c5b7a92caa0"
      },
      "setupActions": [],
      "blockerClasses": [],
      "blockerCount": 0,
      "blockers": [],
      "executionCommands": {
        "preflightCapture": "npm run science:sidecar:runtime-preflight:capture",
        "generateArtifact": "python sidecars/openmdao_dymos/run_optimization.py --problem artifacts/sidecars/openmdao_dymos/moon-logistics-beta.problem.json --out artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
        "validateArtifact": "node scripts/validate-sidecar-intake.mjs --out evidence/sidecar-intake-reports/openmdao-dymos-optimization-v1-runtime-intake-report.json artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
        "regenerateEvidence": "npm run science:sidecar:promotion && npm run science:sidecar:readiness && npm run science:runtime-campaigns && npm run science:runtime-closure && npm run science:release"
      },
      "requiredOutputPath": "artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
      "intakeReportPath": "evidence/sidecar-intake-reports/openmdao-dymos-optimization-v1-runtime-intake-report.json",
      "acceptanceChecklist": [
        "Preflight is current and ready-to-run in the execution shell.",
        "Artifact artifactState is runtime-generated and produced by the sidecar worker, not hand-authored or fixture-derived.",
        "Runtime artifact includes required field: toolVersion.",
        "Runtime artifact includes required field: runAt.",
        "Runtime artifact includes required field: scenarioId.",
        "Runtime artifact includes required field: problemHash.",
        "Runtime artifact includes required field: transcription.",
        "Runtime artifact includes required field: optimizer.",
        "Runtime artifact includes required field: objective.",
        "Runtime artifact includes required field: constraints.",
        "Runtime artifact includes required field: sensitivitySummary.",
        "Runtime artifact includes required field: units.",
        "Runtime artifact includes required field: uncertainty.",
        "Runtime artifact includes required field: reproducibleCommand.",
        "Runtime artifact includes required field: inputsHash.",
        "Runtime artifact includes required field: outputsHash.",
        "Runtime artifact includes required field: checksums.",
        "Runtime artifact includes required field: independentComparison.",
        "Runtime artifact includes required field: limitations.",
        "Runtime artifact includes required field: validationStatus.",
        "Artifact validationStatus is passed.",
        "Artifact sourceIds match the contract source IDs.",
        "Artifact includes reproducibleCommand, inputsHash, outputsHash, and checksums.",
        "Artifact passes npm run science:sidecar:intake and writes an intake report.",
        "A reviewer approves claim-level use before scenario decisions or customer packages change.",
        "Run-spec gate: Artifact id, contract id, scenario id, tool version, run timestamp, source ids, units, uncertainty, limitations, and validation status are populated..",
        "Run-spec gate: inputsHash, outputsHash, checksums, and reproducibleCommand are populated and stable across reruns..",
        "Run-spec gate: Output JSON validates through `npm run science:sidecar:intake` without blockers..",
        "Run-spec gate: The artifact remains non-promotional until the generated intake report is reviewed and placed under evidence/sidecar-intake-reports..",
        "Run-spec gate: independentComparison.status is passed and residual bounds are recorded against at least one independent tool or reviewed reference artifact.."
      ],
      "nextAction": "Regenerate current-shell preflight and reviewer acceptance before using the promoted artifact in customer deliverables.",
      "evidenceBoundary": "Runtime closure records are execution governance only. They do not promote science, trajectory, resource, economics, or customer claims until the referenced runtime artifact and intake report pass.",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "closureHash": "sha256-74b4fe55f2926ca5361cc76212ba324136ae9149fcfb1668f8e89873d058c610"
    }
  ],
  "releaseImpact": "This packet reduces execution ambiguity for runtime science closure, but release remains blocked until required sidecar artifacts are generated, validated, reviewed, and current-shell reproducible.",
  "markdownPath": "public/runtime-closure-packet.md",
  "markdownHash": "sha256-5fa4c71ca1f597211c06e690f5142378e81be03e6eff2683d8dfea7d70df8bec",
  "packetHash": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d"
}
;
